import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'successCreation': false,
  'loading': false,
  'warranty': null,
};

export const addWarranty = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.ADDING_TWC_WARRANTIES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_TWC_WARRANTIES]: (state, action) => ({
      ...state,
      'loading': false,
      'successCreation': true,
      'warranty': action.response.data,
    }),
    [ActionTypes.ADDED_TWC_WARRANTIES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'successCreation': false,
      'warranty': null,
    }),
    [ActionTypes.CLEAR_ADDED_WARRANTY]: (state, action) => ({
      ...state,
      'successCreation': false,
      'warranty': null,
    }),
  })(state, action);
};
